(function () {
  'use strict';

  var recommendationCache = new Map();
  var observedDrawer = null;
  var drawerObserver = null;
  var requestVersion = 0;
  var liveCartSnapshot = null;
  var liveCartSnapshotAt = 0;
  var liveCartSnapshotPromise = null;

  var COUNTDOWN_KEY = 'mg_cart_countdown_end_v1';
  var COUPON_KEY = 'mg_cart_coupon_code_v1';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var timerInterval = null;
  var lastKnownCartCount = Number((window.theme && window.theme.cartCount) || 0);
  var lastKnownCartTotal = 0;
  var pendingOpenAfterRefresh = false;
  var externalSyncTimer = null;
  var cartRerenderFallbackTimer = null;
  var pumperPollToken = 0;
  var pumperMutationActive = false;
  var pumperRecommendationResumeTimer = null;
  var lastPumperTriggerAt = 0;
  var couponUiState = { open: false, code: '', message: '', type: '' };

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    if (window.routes && window.routes.rootUrl) return window.routes.rootUrl.replace(/\/$/, '') + '/';
    return '/';
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cartAddUrl) return window.routes.cartAddUrl + '.js';
    return rootUrl() + 'cart/add.js';
  }

  function cartUpdateUrl() {
    if (window.routes && window.routes.cartUrl) return window.routes.cartUrl.replace(/\/$/, '') + '/update.js';
    return rootUrl() + 'cart/update.js';
  }

  function cartJsonUrl() {
    return rootUrl() + 'cart.js';
  }

  function checkoutUrl() {
    return rootUrl() + 'checkout';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    var parts = (number / 100).toFixed(precision).split('.');
    var amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return amount + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return '$' + formatWithDelimiters(cents, 2, '.', ',');

    var value;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2, '.', ',');
    }
    return format.replace(match[0], value);
  }

  function imageUrl(url, width) {
    if (!url) return '';
    try {
      var result = new URL(url, window.location.origin);
      result.searchParams.set('width', String(width || 160));
      return result.toString();
    } catch (e) {
      return url;
    }
  }

  function boolAttr(value, fallback) {
    if (value == null || value === '') return fallback;
    return String(value) !== 'false';
  }

  function currentDrawer() {
    return document.getElementById('mini-cart');
  }

  function getSettings() {
    var drawer = currentDrawer();
    return {
      countdownEnabled: drawer ? boolAttr(drawer.getAttribute('data-mg-countdown-enabled'), true) : true,
      countdownMinutes: drawer ? Math.max(1, parseInt(drawer.getAttribute('data-mg-countdown-minutes'), 10) || 4) : 4,
      topbarEnabled: drawer ? boolAttr(drawer.getAttribute('data-mg-topbar-urgency-enabled'), true) : true,
      couponEnabled: drawer ? boolAttr(drawer.getAttribute('data-mg-coupon-enabled'), true) : true
    };
  }

  function getStoredDeadline() {
    try {
      return Number(sessionStorage.getItem(COUNTDOWN_KEY) || 0);
    } catch (e) {
      return 0;
    }
  }

  function setStoredDeadline(value) {
    try {
      if (value) sessionStorage.setItem(COUNTDOWN_KEY, String(value));
      else sessionStorage.removeItem(COUNTDOWN_KEY);
    } catch (e) {}
  }

  function getStoredCoupon() {
    try {
      return sessionStorage.getItem(COUPON_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredCoupon(code) {
    try {
      if (code) sessionStorage.setItem(COUPON_KEY, code);
      else sessionStorage.removeItem(COUPON_KEY);
    } catch (e) {}
  }

  function startCountdownIfNeeded(forceAfterExpired) {
    var settings = getSettings();
    if (!settings.countdownEnabled || lastKnownCartCount <= 0) return;

    var now = Date.now();
    var deadline = getStoredDeadline();
    if (!deadline || (forceAfterExpired && deadline <= now)) {
      deadline = now + settings.countdownMinutes * 60 * 1000;
      setStoredDeadline(deadline);
    }
    ensureTimerLoop();
    updateCountdownUI();
  }

  function clearCountdown() {
    setStoredDeadline(0);
    updateCountdownUI();
  }

  function formatCountdown(ms) {
    var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function ensureTimerLoop() {
    if (timerInterval) return;
    timerInterval = window.setInterval(updateCountdownUI, 1000);
  }

  function stopTimerLoopIfIdle() {
    if (!timerInterval) return;
    if (lastKnownCartCount > 0 && getStoredDeadline() > Date.now()) return;
    window.clearInterval(timerInterval);
    timerInterval = null;
  }

  function ensureTopBar() {
    var inner = document.querySelector('.mg-announcement__inner');
    if (!inner) return null;
    var existing = inner.querySelector('[data-mg-cart-topbar]');
    if (existing) return existing;

    var bar = document.createElement('div');
    bar.className = 'mg-cart-topbar';
    bar.setAttribute('data-mg-cart-topbar', '');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<span class="mg-cart-topbar__label">⏱ Tu carrito te espera</span>' +
      '<strong class="mg-cart-topbar__time" data-mg-cart-countdown>04:00</strong>' +
      '<a class="mg-cart-topbar__checkout" data-mg-cart-top-checkout href="' + escapeHtml(checkoutUrl()) + '">FINALIZAR COMPRA</a>';
    inner.appendChild(bar);
    return bar;
  }

  function setTopBarActive(active) {
    var bar = ensureTopBar();
    if (!bar) return;
    var announcementSection = bar.closest('.mg-announcement-section') || bar.closest('[data-section-type="announcement-bar"]');
    if (announcementSection) announcementSection.classList.toggle('mg-cart-urgency-active', !!active);
  }

  function isDrawerOpen() {
    var drawer = currentDrawer();
    return !!(drawer && drawer.getAttribute('aria-hidden') === 'false');
  }

  function updateCountdownUI() {
    var settings = getSettings();
    var deadline = getStoredDeadline();
    var remaining = deadline ? Math.max(0, deadline - Date.now()) : 0;
    var active = settings.countdownEnabled && lastKnownCartCount > 0 && remaining > 0;
    var text = active ? formatCountdown(remaining) : '00:00';

    document.querySelectorAll('[data-mg-cart-countdown]').forEach(function (node) {
      node.textContent = text;
    });

    document.querySelectorAll('[data-mg-cart-timer]').forEach(function (timer) {
      timer.classList.toggle('is-expired', lastKnownCartCount > 0 && !active);
      var copy = timer.querySelector('.mg-cart-timer__copy > span');
      if (copy) copy.textContent = active ? 'Recordatorio activo por' : 'Tu carrito sigue disponible';
    });

    setTopBarActive(!!(active && settings.topbarEnabled && !isDrawerOpen()));
    if (!active) stopTimerLoopIfIdle();
  }

  function currentProductIds(drawer) {
    var ids = new Set();
    if (!drawer) return [];
    drawer.querySelectorAll('.mg-cart-item[data-product-id]').forEach(function (item) {
      var id = item.getAttribute('data-product-id');
      if (id) ids.add(String(id));
    });
    return Array.from(ids);
  }

  function productIdsFromCart(cart) {
    var ids = new Set();
    if (!cart || !Array.isArray(cart.items)) return [];
    cart.items.forEach(function (item) {
      var id = item && (item.product_id || (item.product && item.product.id));
      if (id) ids.add(String(id));
    });
    return Array.from(ids);
  }

  function invalidateLiveCartSnapshot() {
    liveCartSnapshot = null;
    liveCartSnapshotAt = 0;
    liveCartSnapshotPromise = null;
  }

  function getLiveCartSnapshot(force) {
    if (!nativeFetch) return Promise.resolve(null);

    var now = Date.now();
    if (!force && liveCartSnapshot && (now - liveCartSnapshotAt) < 700) {
      return Promise.resolve(liveCartSnapshot);
    }
    if (!force && liveCartSnapshotPromise) return liveCartSnapshotPromise;

    liveCartSnapshotPromise = nativeFetch(cartJsonUrl() + '?mg_recommendations=' + now, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-MG-Cart-Internal': '1' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        // Recommendation reads must be passive. In V4 these GET requests also
        // overwrote lastKnownCartCount/lastKnownCartTotal while Pumper was still
        // finishing a bundle. That could make the drawer lock onto an intermediate
        // pre-discount state. Keep this cache isolated from cart mutation tracking.
        if (cart) {
          liveCartSnapshot = cart;
          liveCartSnapshotAt = Date.now();
        }
        return cart;
      })
      .catch(function () { return null; })
      .finally(function () { liveCartSnapshotPromise = null; });

    return liveCartSnapshotPromise;
  }

  function fetchComplementaries(productId) {
    var key = String(productId);
    if (recommendationCache.has(key)) return recommendationCache.get(key);

    var endpoint = rootUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(key) + '&limit=10&intent=complementary';
    var promise = nativeFetch(endpoint, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return { products: [] };
        return response.json();
      })
      .then(function (data) {
        return data && Array.isArray(data.products) ? data.products : [];
      })
      .catch(function () { return []; });

    recommendationCache.set(key, promise);
    return promise;
  }

  function mergeRoundRobin(groups, cartProductIds, limit) {
    var excluded = new Set(cartProductIds.map(String));
    var seen = new Set();
    var result = [];
    var maxLength = groups.reduce(function (max, group) { return Math.max(max, group.length); }, 0);

    for (var index = 0; index < maxLength && result.length < limit; index++) {
      for (var groupIndex = 0; groupIndex < groups.length && result.length < limit; groupIndex++) {
        var product = groups[groupIndex][index];
        if (!product || !product.available) continue;
        var id = String(product.id);
        if (excluded.has(id) || seen.has(id)) continue;
        var availableVariants = (product.variants || []).filter(function (variant) { return variant.available; });
        if (!availableVariants.length) continue;
        seen.add(id);
        result.push(product);
      }
    }
    return result;
  }

  function productCard(product) {
    var variants = (product.variants || []).filter(function (variant) { return variant.available; });
    if (!variants.length) return '';

    var firstVariant = variants[0];
    var price = firstVariant.price != null ? firstVariant.price : product.price;
    var comparePrice = firstVariant.compare_at_price;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var hasVariants = variants.length > 1;

    var variantSelect = '';
    if (hasVariants) {
      variantSelect = '<select class="mg-cart-upsell__select" data-mg-upsell-variant aria-label="Elegir variante de ' + escapeHtml(product.title) + '">' +
        variants.map(function (variant) {
          var label = variant.public_title || variant.title || 'Opción';
          return '<option value="' + escapeHtml(variant.id) + '" data-price="' + escapeHtml(variant.price) + '" data-compare-price="' + escapeHtml(variant.compare_at_price || '') + '">' + escapeHtml(label) + '</option>';
        }).join('') +
        '</select>';
    }

    var compareHtml = comparePrice && Number(comparePrice) > Number(price)
      ? '<span class="mg-cart-upsell__compare" data-mg-upsell-compare>' + escapeHtml(formatMoney(comparePrice)) + '</span>'
      : '<span class="mg-cart-upsell__compare" data-mg-upsell-compare hidden></span>';

    return '<article class="mg-cart-upsell" data-mg-upsell-product="' + escapeHtml(product.id) + '">' +
      '<a class="mg-cart-upsell__image" href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + escapeHtml(imageUrl(img, 160)) + '" alt="" loading="lazy" width="70" height="70">' : '') +
      '</a>' +
      '<div class="mg-cart-upsell__body">' +
        '<a class="mg-cart-upsell__title" href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '">' + escapeHtml(product.title) + '</a>' +
        '<p class="mg-cart-upsell__price"><span data-mg-upsell-price>' + escapeHtml(formatMoney(price)) + '</span>' + compareHtml + '</p>' +
        variantSelect +
      '</div>' +
      '<button type="button" class="mg-cart-upsell__add" data-mg-upsell-add data-variant-id="' + escapeHtml(firstVariant.id) + '">+ AGREGAR</button>' +
    '</article>';
  }

  function renderRecommendations(drawer, products) {
    var section = drawer.querySelector('[data-mg-cart-upsells]');
    var list = drawer.querySelector('[data-mg-upsell-list]');
    var status = drawer.querySelector('[data-mg-upsell-status]');
    if (!section || !list) return;

    if (!products.length) {
      list.innerHTML = '';
      section.hidden = true;
      if (status) status.textContent = '';
      return;
    }

    list.innerHTML = products.map(productCard).join('');
    section.hidden = false;
    if (status) status.textContent = '';
  }

  function loadRecommendations(drawer) {
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    if (drawer.getAttribute('data-mg-upsells-enabled') === 'false') return;

    // V6: while Pumper is building/repricing an offer, recommendations stay completely
    // passive. This avoids extra cart/recommendation activity until Pumper has finished
    // writing every bundle line and discount allocation.
    if (pumperMutationActive) {
      window.clearTimeout(pumperRecommendationResumeTimer);
      pumperRecommendationResumeTimer = window.setTimeout(function () {
        var activeDrawer = currentDrawer();
        if (!pumperMutationActive && activeDrawer && activeDrawer.getAttribute('aria-hidden') === 'false') {
          loadRecommendations(activeDrawer);
        }
      }, 900);
      return;
    }

    var section = drawer.querySelector('[data-mg-cart-upsells]');
    if (!section) return;

    var version = ++requestVersion;
    var limit = parseInt(drawer.getAttribute('data-mg-upsell-limit'), 10) || 6;
    limit = Math.max(1, Math.min(limit, 10));

    // Always resolve the recommendation sources from Shopify's live cart state.
    // This avoids a race where the drawer HTML still contains the previous product list
    // just after Pumper / another AJAX add has changed the cart.
    getLiveCartSnapshot(true).then(function (cart) {
      if (version !== requestVersion || !document.documentElement.contains(drawer)) return null;

      var ids = productIdsFromCart(cart);
      if (!ids.length) ids = currentProductIds(drawer);

      if (!ids.length) {
        renderRecommendations(drawer, []);
        return null;
      }

      return Promise.all(ids.map(function (productId) {
        return fetchComplementaries(productId);
      })).then(function (groups) {
        if (version !== requestVersion || !document.documentElement.contains(drawer)) return;

        // Re-read the live cart once the complementary requests finish so anything
        // added in the meantime is excluded from the recommendation cards.
        return getLiveCartSnapshot(false).then(function (latestCart) {
          if (version !== requestVersion || !document.documentElement.contains(drawer)) return;
          var currentIds = productIdsFromCart(latestCart);
          if (!currentIds.length) currentIds = currentProductIds(drawer);
          var merged = mergeRoundRobin(groups, currentIds, limit);
          renderRecommendations(drawer, merged);
        });
      });
    });
  }

  function updateKnownCartStateFromDrawer(drawer) {
    if (!drawer) return;
    var count = Number(drawer.getAttribute('data-item-count'));
    var total = Number(drawer.getAttribute('data-mg-cart-total'));
    if (!isNaN(count)) lastKnownCartCount = count;
    if (!isNaN(total)) lastKnownCartTotal = total;
    if (lastKnownCartCount <= 0) clearCountdown();
    else startCountdownIfNeeded(false);
  }

  function restoreCouponUI(drawer) {
    if (!drawer) return;
    var wrap = drawer.querySelector('[data-mg-cart-coupon]');
    if (!wrap) return;

    var storedCode = couponUiState.code || getStoredCoupon();
    var shouldOpen = couponUiState.open || !!storedCode;
    var toggle = wrap.querySelector('[data-mg-coupon-toggle]');
    var panel = wrap.querySelector('[data-mg-coupon-panel]');
    var input = wrap.querySelector('[data-mg-coupon-input]');
    var status = wrap.querySelector('[data-mg-coupon-status]');

    wrap.classList.toggle('is-open', shouldOpen);
    if (toggle) toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (panel) panel.hidden = !shouldOpen;
    if (input && storedCode) input.value = storedCode;
    if (status) {
      status.textContent = couponUiState.message || '';
      status.classList.toggle('is-success', couponUiState.type === 'success');
      status.classList.toggle('is-error', couponUiState.type === 'error');
    }
  }

  function syncOpenState(drawer) {
    var open = drawer && drawer.getAttribute('aria-hidden') === 'false';
    document.body.classList.toggle('mg-cart-is-open', !!open);
    updateCountdownUI();
    if (open) {
      loadRecommendations(drawer);
      restoreCouponUI(drawer);
    }
  }

  function observeDrawer() {
    var drawer = currentDrawer();
    if (!drawer) {
      updateCountdownUI();
      return;
    }

    updateKnownCartStateFromDrawer(drawer);

    if (drawer !== observedDrawer) {
      if (drawerObserver) drawerObserver.disconnect();
      observedDrawer = drawer;
      drawerObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'aria-hidden') {
            syncOpenState(drawer);
            break;
          }
        }
      });
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    restoreCouponUI(drawer);
    syncOpenState(drawer);
  }

  function closeDrawer() {
    var drawer = currentDrawer();
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    var toggle = document.querySelector('[data-action="toggle-mini-cart"][aria-controls="mini-cart"]');
    if (toggle) toggle.click();
  }

  function openDrawer() {
    var drawer = currentDrawer();
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false') return;
    var toggle = document.querySelector('[data-action="toggle-mini-cart"][aria-controls="mini-cart"]');
    if (toggle) toggle.click();
  }

  function requestThemeCartRefresh(openAfter) {
    if (openAfter) pendingOpenAfterRefresh = true;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));

    window.clearTimeout(cartRerenderFallbackTimer);
    cartRerenderFallbackTimer = window.setTimeout(function () {
      if (pendingOpenAfterRefresh) {
        pendingOpenAfterRefresh = false;
        openDrawer();
      }
    }, 1200);
  }

  function exposeCartDrawerApi() {
    window.MilGenialCartDrawer = window.MilGenialCartDrawer || {};

    window.MilGenialCartDrawer.open = function () {
      window.setTimeout(openDrawer, 20);
    };

    window.MilGenialCartDrawer.refresh = function () {
      if (pumperMutationActive) return;
      requestThemeCartRefresh(false);
    };

    window.MilGenialCartDrawer.refreshAndOpen = function () {
      // Used by custom product landing templates. Keep this path native to the
      // theme drawer and avoid clicking /cart links or older third-party drawer
      // events. During a Pumper transaction we do not emit generic cart events;
      // the settled-cart watcher will repaint and open the drawer safely.
      if (pumperMutationActive) {
        pendingOpenAfterRefresh = true;
        return;
      }
      requestThemeCartRefresh(true);
    };

    window.MilGenialCartDrawer.refreshWithCartAndOpen = function (cart) {
      // Some custom landing templates already fetch /cart.js after a Pumper/native
      // add. When they pass that full cart payload we can repaint the drawer
      // quietly from Shopify's current cart state, without generic events that
      // could make bundle apps re-evaluate discounts.
      if (cart && typeof cart.item_count !== 'undefined') {
        commitSettledPumperCart(cart, true);
        return;
      }
      window.MilGenialCartDrawer.refreshAndOpen();
    };

    window.MilGenialCartDrawer.prefetchComplementaries = function (productId) {
      if (!productId || !nativeFetch || pumperMutationActive) return;
      fetchComplementaries(productId);
    };

    window.MilGenialCartDrawer.isPumperActive = function () {
      return !!pumperMutationActive;
    };
  }

  function discountApplications(cart) {
    var apps = [];
    (cart.cart_level_discount_applications || []).forEach(function (app) { apps.push(app); });
    (cart.items || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (allocation) {
        if (allocation && allocation.discount_application) apps.push(allocation.discount_application);
      });
    });
    return apps;
  }

  function codeLooksApplied(cart, code) {
    var normalized = String(code || '').trim().toLowerCase();
    if (!normalized) return false;
    return discountApplications(cart).some(function (app) {
      var title = String((app && (app.title || app.code)) || '').trim().toLowerCase();
      return title === normalized || title.indexOf(normalized) !== -1;
    });
  }

  function applyCoupon(drawer, button) {
    if (!drawer || !nativeFetch) return;
    var input = drawer.querySelector('[data-mg-coupon-input]');
    if (!input) return;
    var code = String(input.value || '').trim();
    var status = drawer.querySelector('[data-mg-coupon-status]');

    couponUiState.open = true;
    couponUiState.code = code;
    couponUiState.message = '';
    couponUiState.type = '';

    if (!code) {
      couponUiState.message = 'Ingresá un código de descuento.';
      couponUiState.type = 'error';
      restoreCouponUI(drawer);
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'APLICANDO…';
    }
    if (status) status.textContent = '';

    nativeFetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-MG-Cart-Internal': '1'
      },
      body: JSON.stringify({ discount: code })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        lastKnownCartCount = Number(cart.item_count || 0);
        lastKnownCartTotal = Number(cart.total_price || 0);
        setStoredCoupon(code);

        if (codeLooksApplied(cart, code)) {
          couponUiState.message = '✓ Cupón aplicado correctamente.';
          couponUiState.type = 'success';
        } else {
          couponUiState.message = 'Código enviado. Si aplica al envío o tiene condiciones especiales, Shopify lo reflejará al finalizar la compra.';
          couponUiState.type = '';
        }

        requestThemeCartRefresh(false);
      })
      .catch(function (error) {
        couponUiState.message = (error && error.description) ? error.description : 'No pudimos aplicar el cupón. Revisá el código e intentá nuevamente.';
        couponUiState.type = 'error';
        restoreCouponUI(drawer);
      })
      .finally(function () {
        var liveButton = currentDrawer() && currentDrawer().querySelector('[data-mg-coupon-apply]');
        if (liveButton) {
          liveButton.disabled = false;
          liveButton.textContent = 'APLICAR';
        }
      });
  }

  function requestUrl(input) {
    try {
      if (typeof input === 'string') return new URL(input, window.location.origin).pathname;
      if (input && input.url) return new URL(input.url, window.location.origin).pathname;
    } catch (e) {}
    return '';
  }

  function requestMethod(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input && typeof input !== 'string' && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  function hasInternalHeader(init) {
    if (!init || !init.headers) return false;
    try {
      if (init.headers instanceof Headers) return init.headers.get('X-MG-Cart-Internal') === '1';
    } catch (e) {}
    if (Array.isArray(init.headers)) {
      return init.headers.some(function (pair) { return String(pair[0]).toLowerCase() === 'x-mg-cart-internal' && String(pair[1]) === '1'; });
    }
    return Object.keys(init.headers || {}).some(function (key) {
      return key.toLowerCase() === 'x-mg-cart-internal' && String(init.headers[key]) === '1';
    });
  }

  function cartMutationType(path, method) {
    if (method === 'GET' || method === 'HEAD') return '';
    if (/\/cart\/add(?:\.js)?\/?$/.test(path)) return 'add';
    if (/\/cart\/(?:change|update|clear)(?:\.js)?\/?$/.test(path)) return 'change';
    return '';
  }

  function queueExternalCartSync(shouldOpen) {
    if (!nativeFetch) return;
    invalidateLiveCartSnapshot();
    if (shouldOpen) pendingOpenAfterRefresh = true;
    window.clearTimeout(externalSyncTimer);
    externalSyncTimer = window.setTimeout(function () {
      nativeFetch(cartJsonUrl() + '?mg_sync=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json', 'X-MG-Cart-Internal': '1' }
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var previousCount = lastKnownCartCount;
          lastKnownCartCount = Number(cart.item_count || 0);
          lastKnownCartTotal = Number(cart.total_price || 0);

          if (lastKnownCartCount <= 0) {
            clearCountdown();
            setStoredCoupon('');
            couponUiState = { open: false, code: '', message: '', type: '' };
          } else if (shouldOpen || (previousCount <= 0 && lastKnownCartCount > 0)) {
            startCountdownIfNeeded(true);
          } else {
            startCountdownIfNeeded(false);
          }

          var drawer = currentDrawer();
          var renderedCount = drawer ? Number(drawer.getAttribute('data-item-count') || 0) : lastKnownCartCount;
          var renderedTotal = drawer ? Number(drawer.getAttribute('data-mg-cart-total') || 0) : lastKnownCartTotal;
          var stale = !drawer || renderedCount !== lastKnownCartCount || renderedTotal !== lastKnownCartTotal;

          if (stale && drawer) requestThemeCartRefresh(shouldOpen);
          else if (shouldOpen) openDrawer();

          updateCountdownUI();
        })
        .catch(function () {});
    }, 320);
  }

  function installFetchBridge() {
    if (!nativeFetch || window.__mgCartFetchBridgeInstalled) return;
    window.__mgCartFetchBridgeInstalled = true;

    window.fetch = function (input, init) {
      var path = requestUrl(input);
      var method = requestMethod(input, init);
      var mutation = cartMutationType(path, method);
      var internal = hasInternalHeader(init);
      var promise = nativeFetch(input, init);

      if (mutation && !internal) {
        promise.then(function (response) {
          if (response && response.ok) queueExternalCartSync(mutation === 'add');
        }).catch(function () {});
      }
      return promise;
    };
  }

  function installXHRBridge() {
    if (!window.XMLHttpRequest || window.__mgCartXHRBridgeInstalled) return;
    window.__mgCartXHRBridgeInstalled = true;

    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__mgCartMethod = String(method || 'GET').toUpperCase();
      try { this.__mgCartPath = new URL(url, window.location.origin).pathname; } catch (e) { this.__mgCartPath = String(url || ''); }
      return originalOpen.apply(this, arguments);
    };

    proto.send = function () {
      var xhr = this;
      var mutation = cartMutationType(xhr.__mgCartPath || '', xhr.__mgCartMethod || 'GET');
      if (mutation) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 400) queueExternalCartSync(mutation === 'add');
        }, { once: true });
      }
      return originalSend.apply(this, arguments);
    };
  }


  function pumperHostFromTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('.prvw_block, [class*="prvw_"], .order-value-booster-block, [data-mg-pumper-host], [data-pumper-app-slot], [data-pumper-native-host]');
  }

  function looksLikePumperAddControl(target) {
    if (!target || !target.closest) return false;
    var control = target.closest('button, input[type="submit"], input[type="button"], [role="button"], a');
    if (!control || !pumperHostFromTarget(control)) return false;
    var label = String(control.textContent || control.value || control.getAttribute('aria-label') || '').trim().toLowerCase();
    if (/agregar|añadir|add to cart|add|comprar|buy now|carrito|cart/.test(label)) return true;
    var classes = String(control.className || '').toLowerCase();
    return /add|cart|buy|submit|atc/.test(classes);
  }

  function pumperCartSignature(cart) {
    if (!cart) return '';
    var items = (cart.items || []).map(function (item) {
      var discounts = (item.discount_allocations || item.discounts || []).map(function (discount) {
        var application = discount && discount.discount_application ? discount.discount_application : discount;
        return [
          String((application && (application.title || application.code || application.type)) || ''),
          Number((discount && (discount.amount || discount.discounted_amount)) || 0)
        ];
      });

      return [
        String(item.key || item.id || ''),
        Number(item.quantity || 0),
        Number(item.original_line_price || item.line_price || 0),
        Number(item.final_line_price != null ? item.final_line_price : (item.line_price || 0)),
        Number(item.total_discount || 0),
        item.properties || {},
        discounts
      ];
    });

    return JSON.stringify({
      item_count: Number(cart.item_count || 0),
      original_total_price: Number(cart.original_total_price || 0),
      total_price: Number(cart.total_price || 0),
      total_discount: Number(cart.total_discount || 0),
      items: items
    });
  }

  function copyDrawerAttributes(target, source) {
    if (!target || !source) return;
    [
      'data-item-count',
      'data-mg-cart-total',
      'data-mg-free-shipping-threshold',
      'data-mg-upsell-limit',
      'data-mg-upsells-enabled',
      'data-mg-countdown-enabled',
      'data-mg-countdown-minutes',
      'data-mg-topbar-urgency-enabled',
      'data-mg-coupon-enabled'
    ].forEach(function (attributeName) {
      if (source.hasAttribute(attributeName)) target.setAttribute(attributeName, source.getAttribute(attributeName));
      else target.removeAttribute(attributeName);
    });
  }

  function quietDrawerRerender(cart, shouldOpen) {
    // V6 Pumper isolation mode:
    // Do NOT dispatch cart:refresh/cart:rerendered/product:added here. Third-party apps
    // can listen to those generic events. During a Pumper offer we only fetch the
    // Liquid cart section and replace our own drawer markup after Pumper is fully done.
    if (!nativeFetch) return Promise.resolve();

    var drawer = currentDrawer();
    var wasOpen = isDrawerOpen();
    var url = rootUrl() + 'cart?section_id=mini-cart&mg_pumper_quiet=' + Date.now();

    return nativeFetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache', 'X-MG-Cart-Internal': '1' }
    })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var fresh = wrapper.querySelector('.mini-cart');
        drawer = currentDrawer();
        if (!fresh || !drawer) return;

        var itemList = drawer.querySelector('.mini-cart__line-item-list');
        var scrollPosition = itemList ? itemList.scrollTop : 0;
        drawer.innerHTML = fresh.innerHTML;
        copyDrawerAttributes(drawer, fresh);

        var newItemList = drawer.querySelector('.mini-cart__line-item-list');
        if (newItemList && scrollPosition) newItemList.scrollTop = scrollPosition;

        var count = cart ? Number(cart.item_count || 0) : Number(drawer.getAttribute('data-item-count') || 0);
        document.querySelectorAll('.header__cart-count').forEach(function (node) {
          node.textContent = String(count);
        });
        if (window.theme) window.theme.cartCount = count;

        observeDrawer();
        restoreCouponUI(drawer);
        updateCountdownUI();

        if (shouldOpen && !wasOpen) window.setTimeout(openDrawer, 20);
        else if (wasOpen) {
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('mg-cart-is-open');
        }
      })
      .catch(function () {});
  }

  function commitSettledPumperCart(cart, shouldOpen) {
    if (!cart) return;
    invalidateLiveCartSnapshot();
    lastKnownCartCount = Number(cart.item_count || 0);
    lastKnownCartTotal = Number(cart.total_price || 0);

    if (lastKnownCartCount > 0) startCountdownIfNeeded(true);
    else clearCountdown();

    // Never use the theme's generic cart refresh event for a Pumper transaction.
    // We repaint the drawer quietly so Pumper keeps sole ownership of bundle state.
    quietDrawerRerender(cart, !!shouldOpen).then(function () {
      updateCountdownUI();
    });
  }

  function watchPumperCartMutation() {
    if (!nativeFetch) return;

    // A normal button click can also produce a submit event a few milliseconds later.
    // Treat both as one Pumper transaction; starting a second watcher could cancel the
    // first while the offer is only half-written.
    var triggerNow = Date.now();
    if (pumperMutationActive && (triggerNow - lastPumperTriggerAt) < 900) return;
    lastPumperTriggerAt = triggerNow;

    // Pumper can perform several writes for one click (paid lines, free lines,
    // hidden bundle properties and discount allocation). V6 treats that whole
    // sequence as an isolated transaction and does not emit any generic cart event.
    invalidateLiveCartSnapshot();
    pumperMutationActive = true;
    requestVersion += 1; // invalidate any recommendation requests already in flight

    var token = ++pumperPollToken;
    var baselineSignature = '';
    var baselineReady = false;
    var tries = 0;
    var maxTries = 52; // ~13 seconds maximum for slow app/function settlement
    var sawMutation = false;
    var stableReads = 0;
    var lastSignature = '';
    var latestCart = null;

    function releasePumperLock() {
      if (token !== pumperPollToken) return;
      pumperMutationActive = false;
      window.clearTimeout(pumperRecommendationResumeTimer);
      pumperRecommendationResumeTimer = window.setTimeout(function () {
        var drawer = currentDrawer();
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') loadRecommendations(drawer);
      }, 450);
    }

    function verifyLateSettlement(settledSignature) {
      // Some Pumper/Shopify Function recalculations land a little later. Recheck twice,
      // still read-only, and repaint only if Shopify's actual cart changed.
      [1800, 3800].forEach(function (delay, index) {
        window.setTimeout(function () {
          if (token !== pumperPollToken) return;
          nativeFetch(cartJsonUrl() + '?mg_pumper_verify=' + Date.now() + '_' + index, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Accept': 'application/json', 'X-MG-Cart-Internal': '1' }
          })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) {
              if (!cart || token !== pumperPollToken) return;
              var signature = pumperCartSignature(cart);
              if (signature && signature !== settledSignature) {
                settledSignature = signature;
                commitSettledPumperCart(cart, false);
              }
              if (index === 1) releasePumperLock();
            })
            .catch(function () { if (index === 1) releasePumperLock(); });
        }, delay);
      });
    }

    function finish(cart, signature) {
      if (!cart || token !== pumperPollToken) return;
      commitSettledPumperCart(cart, true);
      verifyLateSettlement(signature || pumperCartSignature(cart));
    }

    function check() {
      if (token !== pumperPollToken) return;
      tries += 1;

      nativeFetch(cartJsonUrl() + '?mg_pumper_sync=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json', 'X-MG-Cart-Internal': '1' }
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || token !== pumperPollToken) return;
          var signature = pumperCartSignature(cart);

          if (!baselineReady) {
            baselineReady = true;
            baselineSignature = signature;
            latestCart = cart;
            window.setTimeout(check, 220);
            return;
          }

          if (!sawMutation) {
            if (signature !== baselineSignature) {
              sawMutation = true;
              latestCart = cart;
              lastSignature = signature;
              stableReads = 0;
            }
          } else {
            latestCart = cart;
            if (signature === lastSignature) stableReads += 1;
            else {
              lastSignature = signature;
              stableReads = 0;
            }

            // Ten equal reads = ~2.5s stable. Longer than V5 on purpose: a second
            // independent Pumper offer must have time to coexist with the first one
            // before our drawer touches its own DOM.
            if (stableReads >= 10) {
              finish(latestCart, lastSignature);
              return;
            }
          }

          if (tries < maxTries) window.setTimeout(check, sawMutation ? 250 : 220);
          else if (sawMutation && latestCart) finish(latestCart, lastSignature);
          else releasePumperLock();
        })
        .catch(function () {
          if (tries < maxTries) window.setTimeout(check, 300);
          else {
            if (sawMutation && latestCart) finish(latestCart, lastSignature);
            else releasePumperLock();
          }
        });
    }

    // First read happens immediately so the baseline is captured before/while Pumper
    // starts its own request. We never POST/PUT/PATCH anything from this watcher.
    check();
  }

  document.addEventListener('click', function (event) {
    if (looksLikePumperAddControl(event.target)) watchPumperCartMutation();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;

    // V7.3 — do not treat every custom landing product form as a Pumper submit
    // only because the form contains a Pumper placeholder. That false-positive kept
    // recommendations paused for several seconds after a normal AJAX add. The click
    // listener above still catches real Pumper controls; this submit fallback is now
    // limited to forms/submitters that are themselves inside the Pumper UI.
    var submitter = event.submitter || document.activeElement;
    if (pumperHostFromTarget(form) || looksLikePumperAddControl(submitter) || pumperHostFromTarget(submitter)) {
      watchPumperCartMutation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mg-cart-close], [data-mg-cart-backdrop]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var couponToggle = event.target.closest('[data-mg-coupon-toggle]');
    if (couponToggle) {
      event.preventDefault();
      var couponWrap = couponToggle.closest('[data-mg-cart-coupon]');
      var panel = couponWrap && couponWrap.querySelector('[data-mg-coupon-panel]');
      var open = couponWrap ? !couponWrap.classList.contains('is-open') : false;
      if (couponWrap) couponWrap.classList.toggle('is-open', open);
      couponToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
      couponUiState.open = open;
      if (open) {
        var input = couponWrap.querySelector('[data-mg-coupon-input]');
        if (input) window.setTimeout(function () { input.focus(); }, 30);
      }
      return;
    }

    var couponApply = event.target.closest('[data-mg-coupon-apply]');
    if (couponApply) {
      event.preventDefault();
      applyCoupon(currentDrawer(), couponApply);
      return;
    }

    var addButton = event.target.closest('[data-mg-upsell-add]');
    if (!addButton) return;

    var card = addButton.closest('[data-mg-upsell-product]');
    if (!card) return;

    event.preventDefault();
    var select = card.querySelector('[data-mg-upsell-variant]');
    var variantId = select ? select.value : addButton.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'AGREGANDO…';

    nativeFetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-MG-Cart-Internal': '1'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (error) { throw error; });
        }
        return response.json();
      })
      .then(function () {
        invalidateLiveCartSnapshot();
        addButton.textContent = '✓ AGREGADO';
        startCountdownIfNeeded(false);
        addButton.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { button: addButton, variant: null, quantity: 1 }
        }));
      })
      .catch(function (error) {
        var section = card.closest('[data-mg-cart-upsells]');
        var status = section && section.querySelector('[data-mg-upsell-status]');
        if (status) status.textContent = (error && error.description) ? error.description : 'No pudimos agregar este producto. Intentá nuevamente.';
        addButton.disabled = false;
        addButton.textContent = originalText;
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-mg-coupon-input]');
    if (!input) return;
    event.preventDefault();
    var drawer = currentDrawer();
    applyCoupon(drawer, drawer && drawer.querySelector('[data-mg-coupon-apply]'));
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-mg-upsell-variant]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    var card = select.closest('[data-mg-upsell-product]');
    if (!option || !card) return;

    var addButton = card.querySelector('[data-mg-upsell-add]');
    var price = card.querySelector('[data-mg-upsell-price]');
    var compare = card.querySelector('[data-mg-upsell-compare]');

    if (addButton) addButton.setAttribute('data-variant-id', option.value);
    if (price) price.textContent = formatMoney(Number(option.getAttribute('data-price') || 0));

    var compareValue = Number(option.getAttribute('data-compare-price') || 0);
    var priceValue = Number(option.getAttribute('data-price') || 0);
    if (compare) {
      if (compareValue > priceValue) {
        compare.hidden = false;
        compare.textContent = formatMoney(compareValue);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }
  });

  function productIdFromAddedEvent(event) {
    var detail = (event && event.detail) || {};
    var candidates = [
      detail.product_id,
      detail.productId,
      detail.product && detail.product.id,
      detail.item && detail.item.product_id,
      detail.line_item && detail.line_item.product_id,
      detail.variant && detail.variant.product_id
    ];

    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) return candidates[i];
    }

    return null;
  }

  document.addEventListener('product:added', function (event) {
    var productId = productIdFromAddedEvent(event);

    // V7.3 — custom landing speed-up. Landing /cart/add.js responses contain
    // product_id, so pre-warm Search & Discovery while the native theme rerenders
    // the drawer. By the time the cart is open, complementary products are usually
    // already cached or in-flight instead of starting after the HTML refresh.
    if (productId && !pumperMutationActive) {
      fetchComplementaries(productId);
    }

    lastKnownCartCount = Math.max(1, lastKnownCartCount);
    startCountdownIfNeeded(true);
    updateCountdownUI();
  });

  function bridgeDocumentCartRefreshEvents() {
    if (window.__mgDocumentCartRefreshBridgeInstalled) return;
    window.__mgDocumentCartRefreshBridgeInstalled = true;

    /*
      V7 — Custom-template compatibility.
      Several MilGenial landing templates dispatch `cart:refresh` on `document`.
      The theme's Cart controller listens on `document.documentElement`, so those
      events never reached it (events bubble upward, not downward). Re-dispatch
      the exact same refresh from <html> so the native theme rerender runs.

      Important: do not bridge while Pumper is building a bundle. Pumper keeps
      exclusive control of that transaction and our settled-cart watcher will
      repaint the drawer quietly once its discounts are stable.
    */
    document.addEventListener('cart:refresh', function (event) {
      if (event.target !== document || pumperMutationActive) return;

      var detail = event.detail || { scrollToTop: false };
      if (typeof detail.scrollToTop === 'undefined') detail.scrollToTop = false;
      pendingOpenAfterRefresh = true;

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: detail
      }));
    });
  }

  function bindCartRerenderEvent() {
    var cartContainer = document.querySelector('.header__action-item--cart');
    if (!cartContainer || cartContainer.dataset.mgCartBound === 'true') return;
    cartContainer.dataset.mgCartBound = 'true';
    cartContainer.addEventListener('cart:rerendered', function () {
      window.clearTimeout(cartRerenderFallbackTimer);
      invalidateLiveCartSnapshot();
      observeDrawer();
      var drawer = currentDrawer();
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') loadRecommendations(drawer);
      restoreCouponUI(drawer);
      if (pendingOpenAfterRefresh) {
        pendingOpenAfterRefresh = false;
        window.setTimeout(openDrawer, 20);
      }
      updateCountdownUI();
    });
  }

  function init() {
    // Pumper isolation mode: no monkey-patching and no synthetic cart events.
    // Pumper owns its add/discount transaction; we only read cart state and repaint our drawer.
    ensureTopBar();
    exposeCartDrawerApi();
    bridgeDocumentCartRefreshEvents();
    observeDrawer();
    bindCartRerenderEvent();

    var drawer = currentDrawer();
    if (drawer) updateKnownCartStateFromDrawer(drawer);
    if (lastKnownCartCount > 0) startCountdownIfNeeded(false);
    else clearCountdown();
    updateCountdownUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
